module.exports = __webpack_public_path__ + "img/icon-refresh.e78fba07.svg";